import {
    START_ONBOARDING,
    PREV_ONBOARDING,
    NEXT_ONBOARDING,
    VALIDATE_SETUP_PROJECT,
    VALIDATE_SETUP_CHANNELS,
    VALIDATE_CHOOSE_PLUGIN,
    VALIDATE_PLUGIN_CUSTOM,
    VALIDATE_PLUGIN_WORDPRESS,
    VALIDATE_PLUGIN,
    UPDATE_WEBSITE_URL,
    UPDATE_PROJECT_NAME,
    ADD_CHANNEL_ONBOARDING,
    REMOVE_CHANNEL_ONBOARDING,
    SET_CHANNEL_ONBOARDING,
    SET_APPLICATION_CREATED,
    SET_WEBSITE_TYPE
} from './constants'

export function startOnBoarding() {
    return {
        type: START_ONBOARDING,
        payload: {}
    }
}

export function prevStep() {
    return {
        type: PREV_ONBOARDING,
        payload: {}
    }
}

export function nextStep() {
    return {
        type: NEXT_ONBOARDING,
        payload: {}
    }
}

export function validateSetupProject() {
    return {
        type: VALIDATE_SETUP_PROJECT,
        payload: {}
    }
}

export function validateSetupChannels() {
    return {
        type: VALIDATE_SETUP_CHANNELS,
        payload: {}
    }
}

export function validateChoosePlugin(plugin) {
    return {
        type: VALIDATE_CHOOSE_PLUGIN,
        payload: {
            plugin
        }
    }
}

export function validatePlugin() {
    return {
        type: VALIDATE_PLUGIN,
        payload: {}
    }
}

// export function validatePluginWordPress() {
//     return {
//         type: VALIDATE_PLUGIN_WORDPRESS,
//         payload: {}
//     }
// }

// export function validatePluginCustom() {
//     return {
//         type: VALIDATE_PLUGIN_CUSTOM,
//         payload: {}
//     }
// }

export function updateWebsiteUrl(websiteUrl) {
    return {
        type: UPDATE_WEBSITE_URL,
        payload: websiteUrl
    }
}

export function updateProjectName(projectName) {
    return {
        type: UPDATE_PROJECT_NAME,
        payload: projectName
    }
}

export function addChannelOnboarding(name) {
    return {
        type: ADD_CHANNEL_ONBOARDING,
        payload: {
            name
        }
    }
}

export function removeChannelOnboarding(channel) {
    return {
        type: REMOVE_CHANNEL_ONBOARDING,
        payload: {
            channel
        }
    }
}

export function setChannelsOnboarding(channels) {
    return {
        type: SET_CHANNEL_ONBOARDING,
        payload: {
            channels
        }
    }
}

export function setApplicationCreated(application) {
    return {
        type: SET_APPLICATION_CREATED,
        payload: application
    }
}

export function setWebsiteType(websiteType) {
    return {
        type: SET_WEBSITE_TYPE,
        payload: {
            websiteType
        }
    }
}
